import { explode } from "../object/sprite-fx";

class ExpandingSpritesBackgroundFx {

    private scene: Phaser.Scene;
    private colors: number[] = [];
    private textures: string[] = [];
    private sprite1: Phaser.GameObjects.Sprite | null = null;
    private sprite2: Phaser.GameObjects.Sprite | null = null;
    private timeout1: number = -1;
    private timeout2: number = -1;
    private timeout3: number = -1;

    constructor(scene: Phaser.Scene, texture: string | string[] = [], colors: (number | chroma.Color)[] = []){
        this.scene = scene;
        this.textures = typeof texture === 'string' ? [texture] : texture;
        this.colors = colors.map(c => {
            if (typeof c === 'number'){
                return c;
            }
            return c.num();
        })

        this.explode1();
        //this.explode2();
        this.timeout2 = window.setTimeout(() => {
            this.explode2();
        }, 4000)
        
        this.scene.events.on('shutdown', this.destroy, this);
    }

    private getColor() : number {
        if (this.colors.length === 0) return Phaser.Display.Color.RandomRGB().color;
        return Phaser.Utils.Array.GetRandom(this.colors);
    }

    private async explode1(){
        this.sprite1 = this.scene.add.sprite(
            Phaser.Math.Between(0, this.scene.cameras.main.width), 
            0,
            //Phaser.Math.Between(0, this.scene.cameras.main.height / 2),
            Phaser.Utils.Array.GetRandom(this.textures)
        )
            
        //this.sprite1.tint = this.getColor();
        //this.sprite1.scale = 0;
        await explode(this.sprite1, {
            cloneTarget: false,
            scale: 4,
            duration: 8000,//Phaser.Math.Between(6000, 8500),
            tint: this.getColor(), //Not sure why this is necessary, but it is
            onComplete: () => {
                this.sprite1?.destroy();
                this.sprite1 = null;
            }
        })

        this.explode1()
    }

    private async explode2(){
        this.sprite2 = this.scene.add.sprite(
            Phaser.Math.Between(0, this.scene.cameras.main.width),
            this.scene.cameras.main.height,
            //Phaser.Math.Between(this.scene.cameras.main.height / 2, this.scene.cameras.main.height),
            Phaser.Utils.Array.GetRandom(this.textures)
        )
            
        //this.sprite2.tint = this.getColor();
        // this.sprite2.scale = 0;
        await explode(this.sprite2, {
            cloneTarget: false,
            scale: 4,
            duration: 8000, //Phaser.Math.Between(6000, 8500),
            tint: this.getColor(),
            onComplete: () => {
                this.sprite2?.destroy();
                this.sprite2 = null;
            }
        })

        this.explode2()
    }

    setPalette(colors: number[]){
        this.colors = colors;
        if (this.sprite1) this.sprite1.tint = this.getColor();
        if (this.sprite2) this.sprite2.tint = this.getColor();
    }

    destroy(){
        clearTimeout(this.timeout1);
        clearTimeout(this.timeout2);
        clearTimeout(this.timeout3);
    }
}

export default ExpandingSpritesBackgroundFx;